import React from 'react';

const ImageScreen = ({ imageSrc, alt }) => (
    <img src={imageSrc} alt={alt} className="aci-module-image" />
);

export default ImageScreen;
